const { QUERY_LIST, DOMINATE_SC_FOR_SEARCH } = require('./constants');

const isQueryInTilesTest = (query) => QUERY_LIST.includes(query);
const isDlcInTest = (dominateSubCategoryId) => DOMINATE_SC_FOR_SEARCH.includes(dominateSubCategoryId);

module.exports = {
    isQueryInTilesTest,
    isDlcInTest
};
